module.exports = __webpack_public_path__ + "static/img/casual-light.2ba08fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/casual-light.png
// module id = OXBq
// module chunks = 58